import { useEffect, useState } from "react";
import { utilNumber } from "../../../utils/utilNumber";
import "./pager.less";
export var Pager = function (_a) {
    var wrap = _a.wrap, pageCount = _a.pageCount, children = _a.children, page = _a.page;
    var _b = useState(0), currentPage = _b[0], setCurrentPage = _b[1];
    useEffect(function () {
        if (page !== undefined && page > -1) {
            setCurrentPage(page);
        }
    }, [page]);
    var changePage = function (nextPage) {
        var prevPage = currentPage;
        if (prevPage === nextPage) {
            return prevPage;
        }
        var newPage = utilNumber.clamp(nextPage, 0, pageCount - 1);
        if (wrap && newPage === prevPage) {
            newPage = prevPage < nextPage ? 0 : pageCount - 1;
        }
        setCurrentPage(newPage);
        return newPage;
    };
    return children(currentPage, changePage);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/pager/Pager.tsx
// module id = 255
// module chunks = 3